export { default as TabsHost } from './TabsHost';
//# sourceMappingURL=index.js.map